const createAccountContent = {
  en: {
    title: "Account Information",
    titleSignIn: "Log in to your account",
    already: "Already have an account ? ",
    notAlready: "Don't have an account yet?",
    chooseReviewer: " Please start by choosing your reviewer",	 
    titleReset: "Reset your password",
    resetMessage:
      "Don't worry! Just fill in your email and we'll send you a link to reset your password.",
    createOne: "sign up",
    connexion: "Sign in",
    name: "Name",
    email: "Email",
    pass: "Password",
    forgot: "Forgot password",
    accept:
      "By clicking on 'Create an account', you accept our confidentiality policies.",
    cancel: "Cancel",
    validButton: "Create an account",
    loginButton: "Login",
    resetButton: "Reset Password",
  },
  fr: {
    title: "Information sur le compte",
    titleSignIn: "Connectez-vous à votre compte",
    already: "Vous avez déjà un compte ? ",
    notAlready: "Vous n'avez pas encore de compte?",
    chooseReviewer: "Commencez par choisir un lecteur de portfolio",
    titleReset: "Réinitialiser votre mot de passe",
    resetMessage:
      "Ne vous inquétiez pas! Remplissez simplement votre email et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
    connexion: "Connectez-vous",
    createOne: "inscrivez-vous",
    name: "Nom",
    email: "Adresse email",
    pass: "Mot de passe",
    forgot: "Mot de passe oublié?",
    accept:
      "En cliquant sur 'Créer un compte', vous acceptez nos politiques de confidentialité.",
    cancel: "Annuler",
    validButton: "Créer compte",
    loginButton: "Connexion",
    resetButton: "Réinitialiser le mot de passe",
  },
};

export default createAccountContent;
